<template>
  <div class="group-management-container">
    <div class="container">
      <div class="tenant-management-container-add">
        <el-form ref="ruleForm" :model="ruleForm" class="form" :rules="rules">
          <div class="tablist">
            <div :class="activeIndex === 0 ? 'tabitem-av' : 'tabitem'" @click="activeName(0)">
              我的信息
            </div>
            <div :class="activeIndex === 1 ? 'tabitem-av' : 'tabitem'" @click="activeName(1)">
              重置密码
            </div>
          </div>
          <div class="wrapper">
            <div v-if="activeIndex === 0" class="form-container">
              <el-form-item label="姓名" class="form-item required" prop="nickName">
                <el-input
                  v-model="ruleForm.nickName"
                  size="small"
                  placeholder="请输入姓名"
                  clearable
                />
              </el-form-item>
              <el-form-item label="手机号码" class="form-item required" prop="phone">
                <el-input
                  v-model="ruleForm.phone"
                  size="small"
                  clearable
                  placeholder="请输入手机号码"
                />
              </el-form-item>
              <el-form-item>
                <div class="form-btn">
                  <el-button class="cancel-btn" @click="toCancel()">
                    取 消
                  </el-button>
                  <el-button class="true-btn" @click="submitForm('ruleForm')">
                    保 存
                  </el-button>
                </div>
              </el-form-item>
            </div>
            <div v-if="activeIndex === 1" class="form-container">
              <el-form-item key="0" label="原密码" class="form-item required" prop="password">
                <el-input v-model.trim="ruleForm.password" size="small" show-password placeholder="请输入" />
              </el-form-item>
              <el-form-item key="2" label="新密码" class="form-item required" prop="newpassword1">
                <el-input v-model.trim="ruleForm.newpassword1" size="small" show-password placeholder="请输入" />
              </el-form-item>
              <el-form-item key="1" label="确认密码" class="form-item required" prop="checkPass">
                <el-input v-model.trim="ruleForm.checkPass" size="small" show-password placeholder="请输入" />
              </el-form-item>
              <el-form-item>
                <div class="form-btn">
                  <el-button class="cancel-btn" @click="toCancel()">
                    取 消
                  </el-button>
                  <el-button class="true-btn" @click="submitForm('ruleForm')">
                    保 存
                  </el-button>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <popup title="提示" :show.sync="show" content="修改信息将退出登录，请确认是否修改？确认后将返回登录页面。" @toTrue="toTrue" />
  </div>
</template>
<script>
import Popup from '@/components/popup/Popup'
import { getLoginInfo, userInfoEdit } from '@/api/index'
import avatarImage from '@/assets/images/avatar.png'
export default {
  name: 'PersonalIndex',
  components: {
    Popup
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (this.ruleForm.checkPass !== '') {
        this.$refs.ruleForm.validateField('checkPass')
      }
      callback()
    }
    const validatePass2 = (rule, value, callback) => {
      if (value !== this.ruleForm.newpassword1) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      show: false,
      avatarImage,
      activeIndex: 0,
      ruleForm: {
        avatar: '',
        nickName: '', // 昵称
        phone: '',
        password: '', // 原密码
        newpassword1: '', // 密码
        checkPass: ''
      },
      rules: {
        nickName: [
          { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'change' }
        ],
        newpassword1: [
          { required: true, message: '请输入新密码', trigger: 'change' },
          { validator: validatePass, trigger: 'change' },
          { pattern: /^[A-Za-z0-9]+$/, message: '请输入数字或者字母', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入原密码', trigger: 'change' },
          { pattern: /^[A-Za-z0-9]+$/, message: '请输入数字或者字母', trigger: 'change' }
        ],
        checkPass: [
          { required: true, message: '请输入新密码', trigger: 'change' },
          { validator: validatePass2, trigger: 'change' },
          { pattern: /^[A-Za-z0-9]+$/, message: '请输入数字或者字母', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.getLoginInfoData()
  },
  methods: {
    activeName(index) {
      this.activeIndex = index
    },
    getLoginInfoData() {
      getLoginInfo().then((res) => {
        console.log(res.data)
        this.ruleForm.avatar = res.data.avatar
        this.ruleForm.nickName = res.data.nickName
        this.ruleForm.username = res.data.username
        this.ruleForm.phone = res.data.phone
      })
    },
    /**
     * 用户信息修改接口
     */
    getUserInfoEdit() {
      if (this.ruleForm.password) {
        this.ruleForm.nickName = undefined
        this.ruleForm.phone = undefined
      } else {
        this.ruleForm.password = undefined
      }
      this.ruleForm.newpassword1 = this.ruleForm.newpassword1 ? this.ruleForm.newpassword1 : undefined
      userInfoEdit(this.ruleForm.avatar, this.ruleForm.nickName, this.ruleForm.phone, this.ruleForm.password, this.ruleForm.newpassword1, this.ruleForm.username).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$router.push('/login')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitForm(formName) {
      console.log(this.ruleForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.show = true
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    toCancel() {
      this.$router.go(-1)
    },
    // 跳转到登录页
    toTrue() {
      this.getUserInfoEdit()
    },
    // 接口
    uploadSectionFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      // 接口
    },

    // 上传图片之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG 或者 PNG格式!')
      } else {
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
      }
      return (isJPG || isPNG) && isLt2M
    }
  }
}
</script>
<style lang="scss" scoped>
  .group-management-container {
    background-color: #fff;
    width: calc(100% - 40px);
    flex: 1;
    padding: 20px;
    .container {
      display: flex;
      justify-content: center;
      .tenant-management-container-add {
        width: 422px;
        .tablist {
          display: flex;
          justify-content: flex-start;
          div {
            padding: 10px;
          }
          .tabitem {
            cursor: pointer;
          }
          .tabitem-av {
            cursor: pointer;
            color: #FFFFFF;
            background-color: #0085CA;
            border-radius: 8px;
          }
        }
        .wrapper {
          ::v-deep .el-form-item {
            margin-bottom: 14px;
          }
          ::v-deep .el-form-item__content {
            line-height: 32px;
          }
          ::v-deep .el-form-item__label {
            line-height: 32px;
            position: relative;
          }
          .form-container {
            padding-left: 16px;
            margin-top: 29px;
            .forget-name {
              position: absolute;
              right: 0;
              top: 0;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #3370FF;
              cursor: pointer;
            }
            .head{
              width: 100%;
              margin-bottom: 18px;
              >span{
                color: #646A73;
                font-size: 14px;
              }
              >div{
                display: flex;
                display: -webkit-flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-top: 8px;
                .headImage{
                  display: flex;
                  display: -webkit-flex;
                  img{
                    width: 60px;
                    height: 60px;
                    border-radius: 4px;
                    margin-right: 12px;
                  }
                  .upload{
                    .upload__tip{
                      color: #646A73;
                      font-size: 12px;
                      margin-bottom: 11px;
                    }
                  }
                }

                .tag-status{
                  display: flex;
                  display: -webkit-flex;
                  justify-content: flex-end;
                  >span{
                    color: #8691A3;
                    font-size: 16px;
                    margin-right: 8px;
                  }
                  .tag-status-info{
                    width: 67px;
                    height: 24px;
                    line-height: 24px;
                    background: #E1EAFF;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    >img {
                      width: 14px;
                      height: 14px;
                      margin-right: 8px;
                      margin-left: 5px;
                    }
                    >span {
                      font-size: 14px;
                      font-weight: 400;
                    }
                  }
                }
              }
            }
            .required {
              ::v-deep .el-form-item__label {
                line-height: 22px;
                color: #646A73;
                position: relative;
                font-size: 14px;
                &::after {
                  content: '*';
                  color: #FF645F;
                  right: 2px;
                  top: -4px;
                  font-size: 10px;
                  position: absolute;
                }
              }
            }
            .form-item {
              ::v-deep .el-form-item__label:before{
                content: '';
                margin: 0;
              }
            }
            .form-btn {
              margin-top: 26px;
              display: flex;
              justify-content: flex-end;
              .cancel-btn {
                width: 66px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px;
                border: 1px solid #DFE0E3;
                padding: 0px;
                font-size: 14px;
                font-weight: 400;
                color: #1F2329;
              }
              .true-btn {
                width: 66px;
                height: 32px;
                background: #3370FF;
                border-radius: 4px;
                padding: 0px;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                border: 1px solid #3370FF;
              }
            }
          }
        }
      }
    }
  }
</style>
